import styles from './logo.module.css';
import imgSrc from './cykellogo.png';

const Logo = () => {
    return (
        <div className={styles.logoContainer}>
            <a href='/'>
            <img className={styles.logoImg}
                src={imgSrc} 
                alt="Súkklufelag Logo"
            />
            </a>
        </div>
    );
};

export default Logo;
